<template>
  <div class="complaint-list-page">
    <b-row>
      <b-col md="12" lg="12" sm="12">
        <KTCodePreview>
          <template v-slot:preview>
            <div class="complaint-list-page__header mb-4">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Quản lý đơn khiếu nại</h5>
                <div>
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="openCreateModal"
                    class="mr-2"
                  >
                    <i class="flaticon2-plus"></i> Tạo phiếu khiếu nại
                  </b-button>
                  <b-button variant="secondary" size="sm" @click="navigateBack">
                    <i class="flaticon2-back"></i> Quay lại
                  </b-button>
                </div>
              </div>
            </div>

            <b-card v-if="selectedComplaint" class="mb-4">
              <b-card-title class="mb-2">Ghi chú</b-card-title>
              <p class="mb-0 text-muted">
                {{ selectedComplaint.notes || 'Chưa có ghi chú' }}
              </p>
            </b-card>

            <b-card class="mb-4 complaint-list-page__filter-bar">
              <b-row class="complaint-list-page__filter-grid" align-v="end">
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="ID đơn hàng sàn" class="mb-0">
                    <b-form-input
                      v-model="filters.platformOrderId"
                      placeholder="Nhập mã đơn sàn..."
                      size="sm"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="Trạng thái phiếu" class="mb-0">
                    <BDropdownCustom
                      v-model="selectedProcessingStatuses"
                      :options="processingStatusesForDropdown"
                      placeholder="trạng thái phiếu"
                      :match-key="['name']"
                      :searchable="true"
                      :compare-by-id="true"
                      :limit="10"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="Lý do khiếu nại" class="mb-0">
                    <BDropdownCustom
                      v-model="selectedComplaintReasons"
                      :options="complaintReasonsForDropdown"
                      placeholder="lý do"
                      :match-key="['name']"
                      :searchable="true"
                      :compare-by-id="true"
                      :limit="10"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="Đóng case" class="mb-0">
                    <b-form-select
                      v-model="filters.isClosed"
                      class="select-style"
                      :options="isClosedOptions"
                      value-field="value"
                      text-field="text"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="complaint-list-page__filter-grid" align-v="end">
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="Gian hàng" class="mb-0">
                    <BDropdownCustom
                      v-model="selectedMarketplaceConnections"
                      :options="marketplaceConnectionsForDropdown"
                      placeholder="gian hàng"
                      :match-key="['name', 'shopName']"
                      :searchable="true"
                      :compare-by-id="true"
                      :limit="10"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="Ngày tạo từ" class="mb-0">
                    <b-form-input
                      v-model="filters.createdFrom"
                      size="sm"
                      type="date"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" lg="3" class="complaint-list-page__filter-cell">
                  <b-form-group label="Ngày tạo đến" class="mb-0">
                    <b-form-input
                      v-model="filters.createdTo"
                      size="sm"
                      type="date"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  lg="3"
                  class="complaint-list-page__filter-actions d-flex align-items-end justify-content-lg-end"
                >
                  <div class="d-flex flex-wrap justify-content-lg-end w-100">
                    <b-button
                      size="sm"
                      variant="primary"
                      class="complaint-list-page__filter-submit mr-2 mb-2 mb-lg-0"
                      @click="applyFilters"
                    >
                      <i class="flaticon2-search-1 mr-1"></i> Lọc
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      class="complaint-list-page__filter-clear mb-2 mb-lg-0"
                      @click="clearFilters"
                    >
                      <i class="flaticon2-refresh mr-1"></i> Xóa lọc
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-card>

            <div v-if="!loading && items.length === 0" class="text-center py-5">
              <i class="flaticon2-exclamation icon-3x text-muted mb-3"></i>
              <h4 class="text-muted mb-3">Chưa có phiếu khiếu nại nào</h4>
              <b-button variant="primary" @click="openCreateModal">
                <i class="flaticon2-plus"></i> Tạo phiếu khiếu nại
              </b-button>
            </div>

            <ComplaintListTable
              v-if="items.length > 0 || loading"
              :items="items"
              :loading="loading"
              :selected-complaint-id="selectedComplaint && selectedComplaint.id"
              @row-click="selectedComplaint = $event"
              @edit="openEditModal"
              @close="openCloseModal"
            />

            <b-row v-if="items.length > 0 || loading" class="mt-4">
              <b-col>
                <p class="mt-3 text-dark mb-0" style="font-weight: 500">
                  Tổng số: {{ pagination.total }}
                </p>
              </b-col>
              <b-col>
                <b-pagination
                  class="custom-pagination"
                  v-if="numberOfPage >= 2"
                  v-model="pagination.page"
                  :total-rows="pagination.total"
                  :per-page="pagination.limit"
                  @change="onPageChange"
                  align="right"
                  first-class="page-item-first btn btn-icon btn-sm m-1"
                  prev-class="page-item-prev btn btn-icon btn-sm m-1"
                  next-class="page-item-next btn btn-icon btn-sm m-1"
                  last-class="page-item-last btn btn-icon btn-sm m-1"
                  page-class="btn btn-icon btn-sm border-0 m-1"
                >
                  <template v-slot:first-text>
                    <span><i class="ki ki-double-arrow-back icon-xs"></i></span>
                  </template>
                  <template v-slot:prev-text>
                    <i class="ki ki-arrow-back icon-xs"></i>
                  </template>
                  <template v-slot:next-text>
                    <i class="ki ki-arrow-next icon-xs"></i>
                  </template>
                  <template v-slot:last-text>
                    <span class="text-info">
                      <i class="ki ki-double-arrow-next icon-xs"></i>
                    </span>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>

            <create-complaint-modal
              ref="createComplaintModalRef"
              @created="handleComplaintCreated"
            />
            <edit-complaint-modal
              ref="editComplaintModalRef"
              @updated="handleComplaintUpdated"
            />
            <close-case-modal
              ref="closeCaseModalRef"
              @closed="handleCaseClosed"
            />
          </template>
        </KTCodePreview>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { getToastInstance } from '@/utils/toastHelper';
import moment from 'moment';
import CreateComplaintModal from './components/CreateComplaintModal.vue';
import EditComplaintModal from './components/EditComplaintModal.vue';
import CloseCaseModal from './components/CloseCaseModal.vue';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import ComplaintListTable from './components/ComplaintListTable.vue';

const shopeeAdminRepo = RepositoryFactory.get('shopeeAdmin');
const platformRepo = RepositoryFactory.get('platformIntegration');

const toast = getToastInstance();

export default {
  name: 'ComplaintListPage',
  components: {
    KTCodePreview,
    CreateComplaintModal,
    EditComplaintModal,
    CloseCaseModal,
    BDropdownCustom,
    ComplaintListTable,
  },
  data() {
    return {
      items: [],
      loading: true,
      selectedComplaint: null,
      filters: {
        platformOrderId: null,
        complaintId: null,
        isClosed: null,
        createdFrom: '',
        createdTo: '',
      },
      pendingProcessingStatusIds: [],
      selectedProcessingStatuses: [],
      processingStatuses: [],
      pendingComplaintReasonIds: [],
      selectedComplaintReasons: [],
      complaintReasons: [],
      pendingMarketplaceConnectionIds: [],
      selectedMarketplaceConnections: [],
      marketplaceConnections: [],
      isClosedOptions: [
        { value: null, text: 'Tất cả' },
        { value: false, text: 'Đang xử lý' },
        { value: true, text: 'Đã đóng' },
      ],
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
        totalPages: 1,
      },
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kênh bán', route: '/platform-integration' },
      { title: 'Quản lý đơn khiếu nại' },
    ]);
    this.loadFromQuery();
    await Promise.all([
      this.fetchProcessingStatuses(),
      this.fetchComplaintReasons(),
      this.fetchMarketplaceConnections(),
    ]);
    await this.fetchComplaints();
  },
  computed: {
    numberOfPage() {
      return this.pagination.totalPages || 1;
    },
    processingStatusesForDropdown() {
      return this.processingStatuses.map((s) => ({
        ...s,
        shortName: s.id != null ? String(s.id) : '',
      }));
    },
    complaintReasonsForDropdown() {
      return this.complaintReasons.map((r) => ({
        ...r,
        shortName: r.id != null ? String(r.id) : '',
      }));
    },
    marketplaceConnectionsForDropdown() {
      return this.marketplaceConnections.map((c) => ({
        ...c,
        shortName: c.id != null ? String(c.id) : '',
      }));
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadFromQuery();
        this.fetchComplaints();
      },
    },
  },
  methods: {
    loadFromQuery() {
      const q = this.$route.query;
      const rawPid = q.platformOrderId;
      if (rawPid !== undefined && rawPid !== null && String(rawPid).trim() !== '') {
        const s = String(rawPid).trim();
        this.filters.platformOrderId = /^\d+$/.test(s) ? Number(s) : s;
      } else {
        this.filters.platformOrderId = null;
      }
      const rawComplaintId = q.complaintId;
      if (rawComplaintId !== undefined && rawComplaintId !== null && String(rawComplaintId).trim() !== '') {
        const n = Number(String(rawComplaintId).trim());
        this.filters.complaintId = Number.isFinite(n) ? n : null;
      } else {
        this.filters.complaintId = null;
      }
      const rawStatusId = q.processingStatusId;
      if (rawStatusId !== undefined && rawStatusId !== null && String(rawStatusId).trim() !== '') {
        this.pendingProcessingStatusIds = String(rawStatusId)
          .split(',')
          .map((s) => Number(String(s).trim()))
          .filter((n) => Number.isFinite(n));
      } else {
        this.pendingProcessingStatusIds = [];
      }
      const rawReasonId = q.complaintReasonId;
      if (
        rawReasonId !== undefined &&
        rawReasonId !== null &&
        String(rawReasonId).trim() !== ''
      ) {
        this.pendingComplaintReasonIds = String(rawReasonId)
          .split(',')
          .map((s) => Number(String(s).trim()))
          .filter((n) => Number.isFinite(n));
      } else {
        this.pendingComplaintReasonIds = [];
      }
      const rawMcId = q.marketplaceConnectionId;
      if (
        rawMcId !== undefined &&
        rawMcId !== null &&
        String(rawMcId).trim() !== ''
      ) {
        this.pendingMarketplaceConnectionIds = String(rawMcId)
          .split(',')
          .map((s) => Number(String(s).trim()))
          .filter((n) => Number.isFinite(n));
      } else {
        this.pendingMarketplaceConnectionIds = [];
      }
      const from = q.createdFrom != null ? String(q.createdFrom).trim() : '';
      const to = q.createdTo != null ? String(q.createdTo).trim() : '';
      this.filters.createdFrom =
        from && moment(from, 'YYYY-MM-DD', true).isValid() ? from : '';
      this.filters.createdTo =
        to && moment(to, 'YYYY-MM-DD', true).isValid() ? to : '';
      this.filters.isClosed =
        q.isClosed === true || q.isClosed === 'true'
          ? true
          : q.isClosed === false || q.isClosed === 'false'
            ? false
            : null;
      this.pagination.page = q.page ? Number(q.page) : 1;
      this.syncSelectedProcessingStatuses();
      this.syncSelectedComplaintReasons();
      this.syncSelectedMarketplaceConnections();
    },
    syncSelectedProcessingStatuses() {
      if (!this.pendingProcessingStatusIds.length) {
        this.selectedProcessingStatuses = [];
        return;
      }
      if (!this.processingStatuses.length) {
        return;
      }
      this.selectedProcessingStatuses = this.pendingProcessingStatusIds
        .map((id) => this.processingStatuses.find((s) => Number(s.id) === Number(id)))
        .filter(Boolean);
    },
    syncSelectedComplaintReasons() {
      if (!this.pendingComplaintReasonIds.length) {
        this.selectedComplaintReasons = [];
        return;
      }
      if (!this.complaintReasons.length) {
        return;
      }
      this.selectedComplaintReasons = this.pendingComplaintReasonIds
        .map((id) => this.complaintReasons.find((r) => Number(r.id) === Number(id)))
        .filter(Boolean);
    },
    syncSelectedMarketplaceConnections() {
      if (!this.pendingMarketplaceConnectionIds.length) {
        this.selectedMarketplaceConnections = [];
        return;
      }
      if (!this.marketplaceConnections.length) {
        return;
      }
      this.selectedMarketplaceConnections = this.pendingMarketplaceConnectionIds
        .map((id) =>
          this.marketplaceConnections.find((c) => Number(c.id) === Number(id)),
        )
        .filter(Boolean);
    },
    updateQuery() {
      const q = {};
      if (this.filters.platformOrderId)
        q.platformOrderId = this.filters.platformOrderId;
      if (this.filters.complaintId != null) q.complaintId = this.filters.complaintId;
      if (this.selectedProcessingStatuses.length)
        q.processingStatusId = this.selectedProcessingStatuses.map((s) => s.id).join(',');
      if (this.selectedComplaintReasons.length)
        q.complaintReasonId = this.selectedComplaintReasons.map((r) => r.id).join(',');
      if (this.selectedMarketplaceConnections.length)
        q.marketplaceConnectionId = this.selectedMarketplaceConnections
          .map((c) => c.id)
          .join(',');
      if (this.filters.createdFrom) q.createdFrom = this.filters.createdFrom;
      if (this.filters.createdTo) q.createdTo = this.filters.createdTo;
      /* Vue Router có thể bỏ query = false (falsy) → phải dùng chuỗi 'true'|'false' */
      if (this.filters.isClosed === true) q.isClosed = 'true';
      else if (this.filters.isClosed === false) q.isClosed = 'false';
      if (this.pagination.page > 1) q.page = this.pagination.page;
      this.$router.replace({
        name: 'platform-integration-complaints',
        query: q,
      });
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.updateQuery();
    },
    applyFilters() {
      this.pagination.page = 1;
      this.fetchComplaints();
    },
    clearFilters() {
      this.selectedComplaint = null;
      const hadQuery = Object.keys(this.$route.query || {}).length > 0;
      this.$router
        .replace({
          name: 'platform-integration-complaints',
          query: {},
        })
        .catch(() => {});
      if (!hadQuery) {
        this.$nextTick(() => {
          this.loadFromQuery();
          this.fetchComplaints();
        });
      }
    },
    openCloseModal(item) {
      this.$refs.closeCaseModalRef?.open(item);
    },
    navigateBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'platform-integration-list' });
      }
    },
    openCreateModal() {
      this.$refs.createComplaintModalRef?.open();
    },
    openEditModal(item) {
      this.$refs.editComplaintModalRef?.open(item);
    },
    async fetchProcessingStatuses() {
      try {
        const list = await shopeeAdminRepo.getComplaintStatuses();
        const raw = Array.isArray(list) ? list : [];
        this.processingStatuses = raw.map((s) => {
          const id = s.id;
          if (id == null || id === '') return s;
          const num = Number(id);
          return Number.isFinite(num) ? { ...s, id: num } : s;
        });
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách trạng thái xử lý');
        this.processingStatuses = [];
      }
      this.syncSelectedProcessingStatuses();
    },
    async fetchComplaintReasons() {
      try {
        const list = await shopeeAdminRepo.getComplaintReasons();
        const raw = Array.isArray(list) ? list : [];
        this.complaintReasons = raw.map((r) => {
          const id = r.id;
          if (id == null || id === '') return r;
          const num = Number(id);
          return Number.isFinite(num) ? { ...r, id: num } : r;
        });
      } catch (e) {
        toast.makeToastFailure('Không tải được danh mục lý do khiếu nại');
        this.complaintReasons = [];
      }
      this.syncSelectedComplaintReasons();
    },
    async fetchMarketplaceConnections() {
      try {
        const response = await platformRepo.getConfigs({ platform: 'shopee' });
        const raw = Array.isArray(response?.items) ? response.items : [];
        this.marketplaceConnections = raw
          .filter((c) => c.status === 'connected')
          .map((c) => {
            const id = c.id;
            let base = c;
            if (id != null && id !== '') {
              const num = Number(id);
              base = Number.isFinite(num) ? { ...c, id: num } : c;
            }
            const name =
              base.name ||
              base.shopName ||
              (base.shopId != null ? `Shop ${base.shopId}` : `Kết nối #${base.id}`);
            return {
              ...base,
              name,
              shortName: base.id != null ? String(base.id) : '',
            };
          });
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách gian hàng');
        this.marketplaceConnections = [];
      }
      this.syncSelectedMarketplaceConnections();
    },
    async fetchComplaints() {
      if (
        this.filters.createdFrom &&
        this.filters.createdTo &&
        moment(this.filters.createdFrom).isAfter(moment(this.filters.createdTo))
      ) {
        toast.makeToastFailure('Ngày tạo từ không được sau ngày đến');
        return;
      }
      try {
        this.loading = true;
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
        };
        if (this.filters.platformOrderId) {
          params.platformOrderId = this.filters.platformOrderId;
        }
        if (this.selectedProcessingStatuses.length) {
          params.processingStatusId = this.selectedProcessingStatuses.map((s) => s.id).join(',');
        }
        if (this.selectedComplaintReasons.length) {
          params.complaintReasonId = this.selectedComplaintReasons
            .map((r) => r.id)
            .join(',');
        }
        if (this.selectedMarketplaceConnections.length) {
          params.marketplaceConnectionId = this.selectedMarketplaceConnections
            .map((c) => c.id)
            .join(',');
        }
        if (this.filters.createdFrom) {
          params.createdFrom = this.filters.createdFrom;
        }
        if (this.filters.createdTo) {
          params.createdTo = this.filters.createdTo;
        }
        const isClosedVal = this.filters.isClosed;
        if (isClosedVal === true || isClosedVal === 'true') {
          params.isClosed = true;
        } else if (isClosedVal === false || isClosedVal === 'false') {
          params.isClosed = false;
        }
        const res = await shopeeAdminRepo.getComplaintList(params);
        const rawData = res?.data;
        this.items = Array.isArray(rawData)
          ? rawData
          : Array.isArray(rawData?.items)
            ? rawData.items
            : [];
        const pagination = res?.pagination || rawData?.pagination || {};
        this.pagination.total =
          pagination.total ?? pagination.totalItems ?? this.items.length;
        this.pagination.totalPages =
          pagination.totalPages ??
          pagination.totalPage ??
          (Math.ceil(this.pagination.total / this.pagination.limit) || 1);
        this.updateQuery();
        this.$nextTick(() => {
          if (this.filters.complaintId != null) {
            const want = Number(this.filters.complaintId);
            const found = this.items.find((i) => Number(i.id) === Number(want));
            if (found) this.selectedComplaint = found;
          }
        });
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách khiếu nại');
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    handleComplaintCreated() {
      this.fetchComplaints();
    },
    handleComplaintUpdated() {
      this.fetchComplaints();
    },
    handleCaseClosed() {
      this.fetchComplaints();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './styles/shopee-platform-filter-skin.mixin.scss';

.complaint-list-page__filter-bar.card {
  @include shopee-platform-admin-filter-card;
  @include shopee-platform-admin-filter-form;

  ::v-deep .card-body {
    padding: 1rem !important;
  }

  ::v-deep .btn-sm {
    border-radius: 0.28rem;
    font-weight: 600;
    box-shadow: none;
  }
}

.complaint-list-page__filter-grid {
  & + .complaint-list-page__filter-grid {
    margin-top: 0.65rem;
    padding-top: 0.75rem;
    border-top: 1px solid #ebedf3;
  }
}

.complaint-list-page__filter-cell {
  margin-bottom: 0.65rem;
}

@media (min-width: 992px) {
  .complaint-list-page__filter-cell {
    margin-bottom: 0;
  }

  .complaint-list-page__filter-actions {
    margin-bottom: 0;
    padding-bottom: 1px;
  }
}

.complaint-list-page__filter-submit {
  @media (max-width: 991.98px) {
    width: 100%;
  }

  @media (min-width: 992px) {
    min-width: 6.75rem;
  }
}

.complaint-list-page__filter-clear {
  @media (max-width: 991.98px) {
    width: 100%;
  }

  @media (min-width: 992px) {
    min-width: 6.75rem;
  }
}
</style>
